import { createSlice } from '@reduxjs/toolkit'
import { nanoid } from 'nanoid';
import colors from '../../colors.json';

const notesSlice = createSlice({
	name: 'notes',
	initialState: {
		selected: '',
		byId: {},
		allIds: []
	},
	reducers: {
		new_note: {
			reducer(state, action){
				state.byId[action.payload.id] = action.payload
				state.selected = action.payload.id
				state.allIds.push(action.payload.id)
			},
			prepare(note){
				return {payload: 
					{
						id: nanoid(), 
						state: null, 
						created_at: Date.now(), 
						modified_at: Date.now(), 
						datetime: Date.now(), 
						title: '', 
						color: colors[0],
						sections: []
					}
				}
			}
		},
		select_note: (state, action) => {
			state.selected = action.payload
		},
		edit_note: (state, action) => {
			state.byId[action.payload.id] = {...state.byId[action.payload.id], ...action.payload, modified_at: Date.now()}
		},
		add_section_to_note: (state, action) => {
			state.byId[action.payload.id].sections.push(action.payload.section)
		},
		remove_section: (state, action) => {
			console.log(action)
			const index = state.byId[action.payload.id].sections.indexOf(action.payload.section)
			if(index >= 0){
				state.byId[action.payload.id].sections.splice(index, 1)
			}
			// if(state.byId[action.payload.id].sections.length === 0){
			// 	delete state.byId[action.payload.id]
			// 	state.allIds.splice(state.allIds.indexOf(action.payload.id), 1)
			// }
		}
	}
})

export const { new_note, select_note, edit_note, add_section_to_note, remove_section } = notesSlice.actions

export default notesSlice.reducer